import { MySubscriptionComponent } from './lib/orc-my-subscription/my-subscription.component';
export { PauseSubscriptionService } from './lib/public/pause-subscription.service';
export default MySubscriptionComponent;
